/**
 * 메일 이관 API 클라이언트
 *
 * 백엔드 mail_migration 패키지와 매핑되는 endpoint 호출 모음.
 * 사용처: MailMigrationPage.jsx
 */
import { api } from "../../../util/api";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const BASE = `${API_BASE}/mail-migration`;

export const migrationApi = {
    /**
     * 메일함 백업 ZIP 업로드 → 백그라운드 이관 시작.
     *
     * 응답은 잡의 '초기 상태' 다 (처리 결과가 아니다). 진행은 zipStatus 로 폴링한다.
     * 예전엔 .eml 을 건별로 올리고 받은/보낸/스팸/임시를 사용자가 탭으로 골랐는데,
     * 폴더 정보는 백업 경로에 이미 들어 있어서 고르게 할 이유가 없었다.
     *
     * @param {File} file — 사용자가 선택한 .zip
     * @returns {Promise<Object>} 잡 상태 스냅샷
     */
    uploadZip: (file) => {
        const fd = new FormData();
        fd.append("zip", file, file.name);
        return api.upload(`${BASE}/zip`, fd);
    },

    /** 진행 상황 — jobId 생략 시 본인 최근 작업 */
    zipStatus: (jobId) =>
        api.get(`${BASE}/zip/status`, jobId ? { jobId } : {}),

    /** 진행 중인 이관 취소 (이미 들어간 메일은 남는다 — 이력에서 개별 취소) */
    cancelZip: (jobId) =>
        api.post(`${BASE}/zip/cancel${jobId ? `?jobId=${encodeURIComponent(jobId)}` : ""}`),

    /**
     * 본인 업로드 이력 (최신순 페이지)
     *
     * api.get 의 2번째 인자가 '이미' params 다 (util/api.js: `get: (url, params, config) => ...`).
     * 예전엔 `{ params: { page, size } }` 를 넘겨 이중 래핑돼 `params[page]=0&params[size]=30` 으로
     * 나갔고, 서버의 @RequestParam("page"/"size") 는 못 받아 항상 기본값(0/30)으로 동작했다.
     */
    listMyUploads: (page = 0, size = 30) =>
        api.get(`${BASE}/my-uploads`, { page, size }),

    /** 단건 업로드 취소 */
    revertUpload: (uploadId) =>
        api.delete(`${BASE}/uploads/${uploadId}`),
};
